import React, {useContext, useEffect, useState} from 'react'
import {SettingTenantDealerContext} from "../../context/SettingTenantDealerContext"
import parseToken from "../../../../helpers/parseToken"
import {Button, DatePicker, Form, Input, message, Modal, Popconfirm, Select} from "antd"
import {getTenantDealer, updateTenantDealer} from "../../../../services/api/apiSetting"
import {_convertArray} from "../../../../helpers/convertArrayToObject"
import {TYPE_CALL_OUT, TYPE_TALK_TIME} from "../../../../helpers/enum"
import moment from "moment"

const EditTenantParam = (props) => {
    const {tenantId, type} = props
    const SettingTenantPageContext = useContext(SettingTenantDealerContext)
    const {
        listRoles,
        listNumbers,
        listTypeCampaigns,
        getListSettingTenantDealer,
        getListRole
    } = SettingTenantPageContext
    const [form] = Form.useForm();
    const info = parseToken()
    const [isOpen, setIsOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error] = useState('')
    const [fisrtCallOut, setFirstCallOut] = useState('')

    const typeLimitTalkTimeSelect = Form.useWatch('typeLimitTalkTime', form)
    const limitTalkTimeInput = Form.useWatch('limitTalkTime', form)

    const _onToggleModal = () => {
        setIsOpen(!isOpen)
    }

    const _onCancel = () => {
        setIsOpen(false)
        _resetInfo()
    }

    const _resetInfo = () => {
        form.resetFields()
    }

    const onUpdateTenantDealer = async (values) => {
        setLoading(true)

        try {
            const payload = {
                tenantId,
                ...values
            }
            const response = await updateTenantDealer(payload, info.sub)
            const {success, error_message} = response

            if (success !== '1') {
                setLoading(false)
                message.error(error_message)

                return false
            }

            setLoading(false)
            message.success("Cập nhật setting tenant dealer thành công.")
        } catch (e) {
            message.error(e.message)
        }
    }

    const _onSave = async () => {
        await form.validateFields();
        const validationErrors = Object.values(form.getFieldsError());

        if (!validationErrors.find(e => e === undefined)) {
            form.submit()
            setTimeout(() => {
                if (typeof getListSettingTenantDealer === 'function') {
                    getListSettingTenantDealer()
                }
                _onCancel()
            }, 1000)
        }
    }

    const _onSubmitForm = (values) => {
        if (values.callOutAllowed === fisrtCallOut) {
            delete values['callOutAllowed']
        }
        onUpdateTenantDealer(values)
    }

    const _fetchDetail = async () => {
        try {
            const response = await getTenantDealer(tenantId, info.sub)

            const {success, error_message, data} = response

            if (success !== '1') {
                setLoading(false)
                message.error(error_message)

                return false
            }

            setFirstCallOut(data[0].callOutAllowed)

            form.setFields([
                {name: 'tenantName', value: data[0].tenantName},
                {name: 'license', value: data[0].license},
                {name: 'lstRoleId', value: _convertArray(data[0].roleList, 'number')},
                {name: 'lstPhone', value: data[0].callNumber},
                {name: 'lstCampaignType', value: data[0].cpType},
                {name: 'ccuAutoCall', value: data[0].autoCCU},
                {name: 'callRate', value: data[0].autodialerCallRate},
                {name: 'limitTalkTime', value: data[0].limitTalkTime},
                {name: 'typeLimitTalkTime', value: data[0].typeLimitTalkTime},
                {
                    name: 'startDateCheckTalkTime',
                    value: data[0].startDateCheckTalkTime ? moment(data[0].startDateCheckTalkTime, 'DD/MM/YYYY HH:mm:ss') : null
                },
                {name: 'totalTalkTime', value: data[0].totalTalkTime},
                {name: 'callOutAllowed', value: data[0].callOutAllowed},
                {
                    name: 'tenantLockTime',
                    value: data[0].tenantLockTime ? moment(data[0].tenantLockTime, 'DD/MM/YYYY HH:mm:ss') : null
                }
            ])

        } catch (e) {
            message.error(e.message)
        }
    }

    useEffect(() => {
        if (isOpen) {
            _fetchDetail()
            getListRole()
        }
        // eslint-disable-next-line
    }, [isOpen])

    return (
        <>
            <span className="material-icons" onClick={_onToggleModal}>
                {type === 'edit' ? 'border_color' : 'remove_red_eye'}
            </span>
            <Modal
                title={type === 'edit' ? "Cập nhật tenant đại lý" : "Thông tin tenant đại lý"}
                className="ModalCustom2 FormEdit"
                maskClosable={false}
                visible={isOpen}
                footer={[
                    <div className="Actions d-flex justify-content-end align-items-center">
                        <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={_onCancel}
                                    okText="Yes" cancelText="No">
                            <Button key="back" type="link" disable={loading}>
                                Cancel
                            </Button>
                        </Popconfirm>
                        {
                            type === 'edit' &&
                            <Popconfirm placement="top" title="Bạn chắc chắn muốn lưu setting tenant dealer?"
                                        onConfirm={_onSave}
                                        okText="Yes" cancelText="No">
                                <Button key="submit" type="primary" loading={loading}>
                                    Save
                                </Button>
                            </Popconfirm>
                        }
                    </div>
                ]}>
                <div className="FormAddNew">
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={_onSubmitForm}
                    >
                        <div className="row">
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="tenantName">
                                        Mã Tenant:
                                        <span className="Required">*</span>
                                    </label>
                                    <Form.Item
                                        name='tenantName'
                                        rules={[
                                            {
                                                pattern: new RegExp(/^[a-zA-Z0-9]*$/),
                                                message: "Chỉ chấp nhận chữ và số"
                                            },
                                            {
                                                required: true,
                                                message: "Mã tenant là bắt buộc"
                                            }
                                        ]}
                                    >
                                        <Input disabled/>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="license">
                                        Số lượng user:
                                        <span className="Required">*</span>
                                    </label>
                                    <Form.Item
                                        name='license'
                                        rules={[
                                            {
                                                required: true,
                                                message: "Số lượng user là bắt buộc"
                                            },
                                            {
                                                pattern: new RegExp(/^-?\d*(\.\d*)?$/),
                                                message: "Chỉ chấp nhận số"
                                            },
                                        ]}
                                    >
                                        <Input disabled/>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="lstRoleId">
                                        Danh sách quyền:
                                        <span className="Required">*</span>
                                    </label>
                                    <Form.Item
                                        name='lstRoleId'
                                        rules={[
                                            {
                                                required: true,
                                                message: "Danh sách quyền là bắt buộc"
                                            }
                                        ]}
                                    >
                                        <Select
                                            className="SelectMulti"
                                            mode="multiple"
                                            allowClear
                                            style={{width: '100%'}}
                                            placeholder="Vui lòng chọn"
                                            disabled
                                        >
                                            {
                                                listRoles.map((item, index) => (
                                                    <Select.Option key={`parName${index}`} value={item.roleId}>
                                                        {item.roleName}
                                                    </Select.Option>
                                                ))
                                            }
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="lstPhone">
                                        Danh sách đầu số:
                                    </label>
                                    <Form.Item name='lstPhone'>
                                        <Select
                                            showSearch
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            optionFilterProp="children"
                                            className="SelectMulti"
                                            mode="multiple"
                                            allowClear
                                            style={{width: '100%'}}
                                            placeholder="Vui lòng chọn"
                                            disabled={type !== 'edit'}
                                        >
                                            {
                                                listNumbers.map((item, index) => (
                                                    <Select.Option key={`parName${index}`} value={item.parValue}>
                                                        {item.parTitle}
                                                    </Select.Option>
                                                ))
                                            }
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="lstCampaignType">
                                        Loại campaign:
                                    </label>
                                    <Form.Item name='lstCampaignType'>
                                        <Select
                                            className="SelectMulti"
                                            mode="multiple"
                                            allowClear
                                            style={{width: '100%'}}
                                            placeholder="Vui lòng chọn"
                                            disabled={type !== 'edit'}
                                        >
                                            {
                                                listTypeCampaigns.map((item, index) => (
                                                    <Select.Option key={`parName${index}`} value={item.parValue}>
                                                        {item.parTitle}
                                                    </Select.Option>
                                                ))
                                            }
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="ccuAutoCall">
                                        Giới hạn CCU autocall:
                                    </label>
                                    <Form.Item
                                        name='ccuAutoCall'
                                        rules={[
                                            {
                                                pattern: new RegExp(/^-?\d*(\.\d*)?$/),
                                                message: "Chỉ chấp nhận số"
                                            },
                                        ]}
                                    >
                                        <Input disabled={type !== 'edit'}/>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="callRate">
                                        Giới hạn tốc độ quay số:
                                    </label>
                                    <Form.Item
                                        name='callRate'
                                        rules={[
                                            {
                                                pattern: new RegExp(/^-?\d*(\.\d*)?$/),
                                                message: "Chỉ chấp nhận số"
                                            },
                                        ]}
                                    >
                                        <Input placeholder='Tốc độ quay số' disabled={type !== 'edit'}/>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="limitTalkTime">
                                        Giới hạn cước (số phút):
                                    </label>
                                    <Form.Item
                                        name='limitTalkTime'
                                        rules={[
                                            {
                                                pattern: new RegExp(/^-?\d*(\.\d*)?$/),
                                                message: "Chỉ chấp nhận số"
                                            },
                                        ]}
                                    >
                                        <Input placeholder='Nhập số phút gọi' disabled={type !== 'edit'}/>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="callOutAllowed">
                                        Trạng thái gọi ra:
                                    </label>
                                    <Form.Item
                                        name='callOutAllowed'
                                    >
                                        <Select
                                            id="callOutAllowed"
                                            name="callOutAllowed"
                                            placeholder="Vui lòng chọn trạng thái gọi ra"
                                        >
                                            {
                                                TYPE_CALL_OUT.map((item, index) => (
                                                    <Select.Option key={`typeCallOut${index}`} value={item.value}>
                                                        {item.name}
                                                    </Select.Option>
                                                ))
                                            }
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="totalTalkTime">
                                        Số phút đã gọi:
                                    </label>
                                    <Form.Item
                                        name='totalTalkTime'
                                    >
                                        <Input placeholder='Nhập số phút đã gọi' disabled/>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="typeLimitTalkTime">
                                        Loại tính cước:
                                    </label>
                                    <Form.Item
                                        name='typeLimitTalkTime'
                                        rules={[
                                            limitTalkTimeInput && {
                                                required: true,
                                                message: "Loại tính cước là bắt buộc"
                                            }
                                        ]}
                                    >
                                        <Select
                                            id="typeLimitTalkTime"
                                            name="typeLimitTalkTime"
                                            placeholder="Vui lòng chọn loại tính cước"
                                        >
                                            {
                                                TYPE_TALK_TIME.map((item, index) => (
                                                    <Select.Option key={`limitTime${index}`} value={item.value}>
                                                        {item.name}
                                                    </Select.Option>
                                                ))
                                            }
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                            {
                                (typeLimitTalkTimeSelect === 'MONTH' || typeLimitTalkTimeSelect === 'BLOCK') &&
                                <div className="col-md-6">
                                    <div className="FieldItem">
                                        <label className="Label" htmlFor="startDateCheckTalkTime">
                                            Thời gian bắt đầu tính cước:
                                        </label>
                                        <Form.Item name='startDateCheckTalkTime'>
                                            <DatePicker
                                                id='startDateCheckTalkTime'
                                                name='startDateCheckTalkTime'
                                                allowClear={true}
                                                format="HH:mm DD/MM/YYYY"
                                                showTime={true}
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                            }
                            {
                                typeLimitTalkTimeSelect === 'Time' && <div className="col-md-6">
                                    <div className="FieldItem">
                                        <label className="Label" htmlFor="tenantLockTime">
                                            Thời gian khóa cước:
                                        </label>
                                        <Form.Item name='tenantLockTime'>
                                            <DatePicker
                                                id='tenantLockTime'
                                                name='tenantLockTime'
                                                allowClear={true}
                                                format="HH:mm DD/MM/YYYY"
                                                showTime={true}
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                            }
                        </div>
                    </Form>
                    {error && <div className="text-danger mt-3">{error}</div>}
                </div>
            </Modal>
        </>
    )
}

export default EditTenantParam
